/* unplugin-vue-components disabled */import script from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"

import "./message-bubble.vue?vue&type=style&index=0&id=29ab623c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ab623c"]])

export default __exports__